import DeleteInvoiceContainer from "./DeleteInvoiceContainer";

export default DeleteInvoiceContainer;
